import React from "react";
import { ServiceTypeEnum } from "src/components/Premises";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";
import { HandoverTypeEnum } from "../../types";

export const useCloseTransferFormSetFieldValueEffect = ({
  formikContext: { values, setFieldValue },
  formBehavior: { hasElectricitySection, hasGasSection },
}: Pick<
  ReturnType<typeof useCloseTransferFormProps>,
  "formikContext" | "formBehavior"
>) => {
  const { closeTransfer } = values;

  const isOnlyOneServiceType = hasElectricitySection !== hasGasSection;
  React.useEffect(() => {
    const autoSelectServiceType = () => {
      //under this case, there is only one service type
      if (isOnlyOneServiceType) {
        const serviceType = hasElectricitySection
          ? ServiceTypeEnum.ELECTRICITY
          : ServiceTypeEnum.GAS;
        if (!closeTransfer.serviceTypes.includes(serviceType)) {
          setFieldValue("closeTransfer.serviceTypes", [
            ...closeTransfer.serviceTypes,
            serviceType,
          ]);
        }
      }
    };
    autoSelectServiceType();
  }, [isOnlyOneServiceType, closeTransfer.serviceTypes]);

  //clean up the signedTransferFormFiles when handoverType is CLOSE
  React.useEffect(() => {
    if (closeTransfer.handoverType === HandoverTypeEnum.CLOSE) {
      setFieldValue("closeTransfer.signedTransferFormFiles", []);
    }
  }, [closeTransfer.handoverType]);
};
